import { render, staticRenderFns } from "./ImageUploder.vue?vue&type=template&id=5c00b86d&scoped=true"
import script from "./ImageUploder.vue?vue&type=script&lang=js"
export * from "./ImageUploder.vue?vue&type=script&lang=js"
import style0 from "./ImageUploder.vue?vue&type=style&index=0&id=5c00b86d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c00b86d",
  null
  
)

export default component.exports